<div class="wrapper">
  <div class="header">
    <div class="header-content">Unsaved changes</div>
    <img class="close-image" (click)="cancel()" src="./assets/icons/cancel.svg" />
  </div>
  <div class="content">If you leave this page, any unsaved changes will be lost.</div>
  <div class="buttons">
    <div>
      <pdq-button label="Cancel" variant="light" (onClick)="cancel()"></pdq-button>
    </div>
    <div class="second-btn">
      <pdq-button label="Leave page" variant="danger" (onClick)="leavePage()"></pdq-button>
    </div>
  </div>
</div>
